import { DeveloperExitFinanceLoanInput, DeveloperExitFinanceLoanInputClient } from "@src/apis/ModularClient";

export class DeveloperExitFinanceLoanInputController {
  selectedSection: string;

  objects: DeveloperExitFinanceLoanInput[];
  selectedObject: DeveloperExitFinanceLoanInput;

  fetchingObjects: boolean;
  fetchingObject: boolean;

  //addingSubobject: boolean;

  //subobjects: SubobjectDTO[];
  //selectedSubobject: SubobjectDTO;

  //fetchingSubobjects: boolean;
  //fetchingSubobject: boolean;

  developerexitfinanceloaninputForm: ng.IFormController;
  //subdeveloperexitfinanceloaninputForm: ng.IFormController;

  static $inject = ["$routeParams", "DeveloperExitFinanceLoanInputClient"];
  //private $subobjectservice: App.Services.SubobjectService
  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private developerExitFinanceLoanInputClient: DeveloperExitFinanceLoanInputClient,
  ) {
    this.updateObjects();
  }

  updateObjects() {
    this.fetchingObjects = true;

    // Fetch all objects.
    this.developerExitFinanceLoanInputClient
      .list()
      .then((response) => {
        this.objects = response;
        this.preSelectedItem();
      })
      .finally(() => {
        this.fetchingObjects = false;
      });
  }

  private preSelectedItem() {
    if (this.$routeParams.Id) {
      let selectedObject = this.objects.find((value, index) => {
        return value.id === parseInt(this.$routeParams.objectId);
      });

      this.selectObject(selectedObject);
    }
  }

  selectObject(object: DeveloperExitFinanceLoanInput) {
    this.selectedObject = object;

    //this.fetchingSubobjects = true;
    //this.$subobjectservice.fetchSubobjectsForObject(object.Id).then((response) => {
    //    this.subobjects = response;
    //    this.fetchingSubobjects = false;
    //}).catch((response) => {
    //    this.fetchingSubobjects = false;
    //});

    this.selectedSection = "details";
  }

  createObject() {
    this.selectedSection = "details";
    this.selectedObject = {} as DeveloperExitFinanceLoanInput;
  }

  save() {
    this.developerExitFinanceLoanInputClient.addUpdateReturnOnlyID(this.selectedObject).then((response) => {
      this.selectedObject.id = response;
      if (!this.objects) {
        this.objects = [];
      }

      let matches: DeveloperExitFinanceLoanInput[] = this.objects.filter((value, index) => {
        return value.id == response;
      });

      if (!matches || matches.length === 0) {
        this.objects.push(this.selectedObject);
      }

      this.developerexitfinanceloaninputForm.$setPristine();
      this.updateObjects();
    });
  }

  delete() {
    this.developerExitFinanceLoanInputClient.markAsDeleted(this.selectedObject.id).then((response) => {
      if (response) {
        this.objects.splice(this.objects.indexOf(this.selectedObject), 1);
        this.developerexitfinanceloaninputForm.$setPristine();
        delete this.selectedObject;
      }
    });
  }

  //addSubobject() {
  //    this.selectedSubobject = {
  //        AssociatedObjectId: this.selectedObject.Id,
  //        AssociatedObjectName: this.selectedObject.Name
  //    } as SubobjectDTO;
  //}

  //removeSubobject(subobject: SubobjectDTO) {
  //    this.$subobjectservice.deleteSubobject(subobject.Id).then((response) => {
  //        this.subobjects.splice(this.subobjects.indexOf(this.selectedSubobject), 1);
  //        delete this.selectedSubobject;
  //    });
  //}

  //cancelUpdateSubobject() {
  //    delete this.selectedSubobject;
  //}

  //updateSubobject(subobject: SubobjectDTO) {
  //    this.$subobjectservice.addUpdateSubobject(subobject).then((response) => {
  //        if (this.subobjects.indexOf(subobject) === -1) {
  //            this.subobjects.push(subobject);
  //        }
  //        delete this.selectedSubobject;
  //    }).catch((response) => {
  //        delete this.selectedSubobject;
  //    });

  //}
}
